import { colors } from "@mui/material";
import { PuzzleGamePlugin } from "interfaces/puzzle-game-plugin";

export interface ChatAttachment {
	_id: string;
	name: string;
	fileUrl?: string;
	link?: string;
	/**
	 * Puzzle game plugin, which holds embedded puzzle information.
	 * If this data exist, this means that the attachment is an embedded puzzle.
	 */
	puzzleGamePlugin?: PuzzleGamePlugin;
	protection?: {
		locked: boolean;
		password: string;
	};
}
export interface ChatMessage {
	_id: string;
	id: string;
	from: string;
	to: string;
	text?: string;
	timestamp: Date;
	attachments?: ChatAttachment[];
}

export const chatBorderColor = colors.grey["400"];
